import React from 'react';
import AnimatedServicesSection from '../components/AnimatedServicesSection';
import ServicesPinnedSection from '../components/ServicesPinnedSection';
import IntroParallaxSection from '../components/IntroParallaxSection'; // We'll use this here
import ServiceParallaxSection from '../components/ServiceParallaxSection';
import TestimonialCollage from '../components/TestimonialCollage';
import WhoWeAre from '../components/WhoWeAre';
import FuturisticMap from '../components/FuturisticMap';
import GlobalPresence from '../components/GlobalPresence';
import ContactForm from '../components/ContactForm'

export default function ServicesPage() {
  return (
    <main>
      {/* <AnimatedServicesSection />
      <ServicesPinnedSection /> */}
      <IntroParallaxSection />
      <ServiceParallaxSection />
      {/* <TestimonialCollage /> */}
      
      {/* <FuturisticMap
        center={[77.5946, 12.9716]} // Bengaluru
        zoom={11}
        autoRotate={true}
      /> */}
    </main>
  );
}